import React, { ReactElement, useState, useCallback } from "react"
import { AccordionContext } from "contexts/components/AccordionContext"
import "./accordion.module.scss"

interface AccordionProps {
  children: ReactElement | ReactElement[]
  isFAQ?: boolean
  firstActivePanel?: string
}

export const Accordion = ({
  children,
  firstActivePanel = "",
  isFAQ = false,
}: AccordionProps) => {
  const [activePanel, setActivePanel] = useState(firstActivePanel)

  const handlePanelClick = useCallback((id: string) => {
    setActivePanel(state => (state !== id ? id : ""))
  }, [])

  return (
    <AccordionContext.Provider
      value={{
        activePanel,
        handlePanelClick,
        isFAQ,
      }}
    >
      <dl className="fr-accordion">{children}</dl>
    </AccordionContext.Provider>
  )
}
